var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144 160",
    width: 144,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "d_bg-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #f6f7f9 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m108 33h18c0 69.6-56.4 126-126 126v-18c59.7 0 108-48.4 108-108z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m0-39v-18c49.7 0 90 40.3 90 90 0 49.7-40.3 90-90 90v-18c39.8 0 72-32.2 72-72 0-39.8-32.2-72-72-72z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m0-21c29.8 0 54 24.2 54 54 0 29.8-24.2 54-54 54v-54h-54c0-29.8 24.2-54 54-54z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDBg);
export default __webpack_public_path__ + "static/media/d_bg.1e137b7e299c7e6935c87d0b74238a44.svg";
export { ForwardRef as ReactComponent };